import {LOCATE_APP_OPTIONS} from "../types";

const showAppOptions= (visible) => {
  return ({type: LOCATE_APP_OPTIONS, payload: {visibleAppOptions: visible}});
};
export default showAppOptions;